<template>
  <div class="mt-2">
    <!-- {{ currentModule }} -->
    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item, list-item-three-line, list-item-three-line, list-item-three-line,list-item,  list-item-three-line"
      ></v-skeleton-loader>
    </div>
    <div v-else-if="data">
      <v-list dense shaped color="transparent">
        <v-subheader v-if="!isSubscribed"
          >(E/M &amp; CPT codes are an EyeDock Pro feature)</v-subheader
        >
        <v-list-item-group
          color="primary"
          dense
          v-model="selected"
          v-for="type in ['EM', 'CPT']"
          :key="type"
          class="mb-4"
        >
          <v-list-item
            :value="type.toLowerCase()"
            @click="setDetail(type.toLowerCase())"
            :disabled="!isSubscribed"
          >
            <span class="overline"
              ><u>{{ type == "EM" ? "E/M" : "CPT" }} Codes</u></span
            ></v-list-item
          >
          <v-list-item
            dense
            v-for="(item, i) in data[type]"
            :key="type + i"
            :value="item.tag"
            @click="setDetail(item.tag)"
            :disabled="!isSubscribed"
          >
            <v-list-item-content dense>
              <v-list-item-title dense>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="type == 'CPT'"
            @click="setDetail('modifiers')"
            value="modifiers"
            class="mt-4"
          >
            <span class="overline"><u>Modifiers</u></span></v-list-item
          >
        </v-list-item-group>
        <coding-see-also currentItem="billing-codes"></coding-see-also>
        <!-- <v-divider></v-divider>
       
        <v-list-item-group>
        </v-list-item-group> -->
      </v-list>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import CurrentModuleMixin from "@/assets/js/CurrentModuleMixin";
import UserMixin from "@/assets/js/UserMixin";
import CodingSeeAlso from "./CodingSeeAlso.vue";

export default {
  name: "BillingMenuBtns",
  components: {
    CodingSeeAlso,
  },
  mixins: [CurrentModuleMixin, UserMixin],
  props: {},
  data: function () {
    return {
      loading: true,
      data: null,
      selected: "em",
      iconSrc: "https://www.eyedock.com/images/menu_icons/",
    };
  },
  methods: {
    callApi() {
      this.loading = true;
      ApiServices.genericApiCall("/billing/menuOptions")
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setDetail(detail) {
      // console.log("setDetail", detail, this.currentModule);
      if (this.currentModule == "billingCodes") {
        this.$store.dispatch("setModeAndDetail", {
          mode: null,
          detail: detail,
        });
      } else {
        this.$router.push({
          path: "/billing-codes#detail=" + detail,
        });
      }
    },
    setSelected(detail) {
      this.selected = detail;
    },
  },
  computed: {
    storedItem: function () {
      return this.$store.state.detail;
    },
  },
  watch: {
    storedItem(val) {
      // console.log("setcategory");
      this.setSelected(val);
    },
  },
  mounted() {
    if (this.storedItem) this.setSelected(this.storedItem);
    // if (this.currentModule == "billing-protocols") this.selected = null;
    this.callApi();
  },
};
</script>

<style scoped></style>
